angular.module('meevo.plugins.egifts').filter('guideCheck', function () {
    return function (cardNumber) {
        let pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if (cardNumber === undefined) return;
        if (cardNumber.search(pattern) !== -1) return 'UNASSIGNED';
        return cardNumber;
    };
});